import React, { useState, useEffect } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown } from "react-bootstrap";
import "./Ethics.scss";
import Content from "./Content"
import ReactPlayer from 'react-player';
import { Close } from "../../icon/icon";
import { getSrc } from "gatsby-plugin-image";

import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const titleVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    delay: 1.5,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

const Ethics = (props) => {

  const [isPlay, setPlay] = useState(true);
  const [videoID, SetvideoID] = useState("none");
  return (
    <InView {...inViewOptions}>
      {({ ref, inView }) => {
        return (
          <motion.section
            ref={ref}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={containerVariants}
          >
            <React.Fragment>
              {props?.sections?.map((item, index) => (

                <section className="ethics-section">
                  <Container>
                    <Row>
                      {index % 2 == 0 ?
                        <Col className="order-md-1 order-2" lg={{ size: 5 }}>
                          <div className="ethics-aside-img img-hover-zoom inline-video-wrapper">
                            <ScrollAnimation animateOnce={true} animateIn="zoomIn">
                              {/* <picture>
                      <source media="(min-width:992px)" srcSet={item.Image?.url} />
                      <source media="(min-width:768px)" srcSet={item.Image?.url} />
                      <img src={item.Image?.url} alt={item.Image?.alternativeText} />
                    </picture> */}
                              <img src={getSrc(item?.Image?.url_sharp)} alt={item?.Image?.alternativeText} />
                            </ScrollAnimation>
                            
                            {isPlay && item.Video_Url && videoID === index &&
                              <div className="inline-video">
                                <div className="close-video-inline">
                                  <a href="javascript:;" className="video-arrow" onClick={e => { setPlay(false); SetvideoID("none"); }}>
                                    <Close />
                                  </a>
                                </div>
                                <ReactPlayer autoplay url={item.Video_Url} controls={true} autoplay={true} playsinline={true} playing={true} width='100%' height='100%' onEnded={() => { setPlay(false); }} />
                              </div>
                            }
                            {item.Video_Url && videoID != index &&
                              <>
                                <a href="javascript:;" className="video-arrow" onClick={e => { setPlay(true); SetvideoID(index); }}>
                                  <span class="video-btn"><i class="icon-video"></i></span>
                                </a>
                              </>
                            }
                          </div>
                        </Col>
                        : null}
                      <Col lg={7} className={index % 2 == 0 ? "ethics-section-text-content order-md-2 order-1" : "ethics-section-text-content right order-md-1 order-1"}>
                        <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
                          <div className="ethics-content">
                            <h2>{item.Title}</h2>
                            <Content Content={item.Content} />
                          </div>
                        </ScrollAnimation>
                      </Col>
                      {index % 2 !== 0 ?
                        <Col className="order-md-2 order-2" lg={{ size: 5 }}>
                          <div className="ethics-aside-img img-hover-zoom">
                            <ScrollAnimation animateOnce={true} animateIn="zoomIn">
                              {/* <picture>
                      <source media="(min-width:992px)" srcSet={item.Image?.url} />
                      <source media="(min-width:768px)" srcSet={item.Image?.url} />
                      <img src={item.Image?.url} alt={item.Image?.alternativeText} />
                    </picture> */}
                              <img src={getSrc(item?.Image?.url_sharp)} alt={item?.Image?.alternativeText} />
                            </ScrollAnimation>
                          </div>
                        </Col>
                        : null}
                    </Row>
                  </Container>
                </section>
              ))}
            </React.Fragment>
          </motion.section>
        )
      }}
    </InView>
  )
}

export default Ethics;